import i18n from "i18next";
import { SalespersonView } from "src/api/generated/erp/db/types/tables/salespersonView.ts";
import { SalespersonApi } from "src/api/generated/erp/sales/masterData/api/salespersonApi.ts";
import { useFormInput } from "src/components/common/dialogs/formInput/useFormInput.tsx";
import { FormAsyncSelectField } from "src/components/common/forms/fields/FormAsyncSelectField.tsx";
import { FormCheckbox } from "src/components/common/forms/fields/FormCheckbox.tsx";
import { requireRule } from "src/components/common/forms/validation.ts";

export interface SalesLeadAllocationDialogResult {
	salespersonId: number;
	moveOpenActivities: boolean;
}

export const useSalesLeadAllocationDialog = (): (() => Promise<SalesLeadAllocationDialogResult | undefined>) => {
	const showFormInput = useFormInput();

	return () =>
		showFormInput<SalesLeadAllocationDialogResult>({
			title: i18n.t("allocate_lead"),
			size: "sm",
			submitLabel: i18n.t("allocate_lead"),
			defaultValues: {
				moveOpenActivities: false,
			},
			content: ({ control }) => (
				<>
					<FormAsyncSelectField<SalesLeadAllocationDialogResult, SalespersonView, number, "salespersonId">
						control={control}
						name={"salespersonId"}
						label={i18n.t("salesperson")}
						autoFocus
						fetchOptions={({ searchQuery }) =>
							SalespersonApi.getSalespersons({
								includeInactive: false,
								searchQuery,
							})
						}
						getOptionKey={(salesperson) => salesperson.salespersonId}
						getOptionLabel={(salesperson) => salesperson.name}
						rules={requireRule()}
					/>
					<FormCheckbox
						control={control}
						name={"moveOpenActivities"}
						label={i18n.t("move_open_sales_lead_activities_to_new_salesperson")}
						helperText={i18n.t("move_open_sales_lead_activities_to_new_salesperson_helper")}
					/>
				</>
			),
		});
};
